import { action } from 'satcheljs/lib/legacy';
import addReadWriteRecipients from '../addReadWriteRecipients';
import isRecipientWellWithFindControlViewState from '../../utils/isRecipientWellWithFindControlViewState';
import { FindResultType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import showHideFindResult from '../showHideFindResult';

export default action('postProcessSuggestionsResult')(function postProcessSuggestionsResult(
    recipientWell: FindControlViewState | RecipientWellWithFindControlViewState,
    recipients: ReadWriteRecipientViewState[],
    resultType: FindResultType,
    resolveIfSingle?: boolean
) {
    if (
        recipientWell.findResultSet.length == 1 &&
        resolveIfSingle &&
        isRecipientWellWithFindControlViewState(recipientWell)
    ) {
        // Autoresolve if there's only a single result.
        addReadWriteRecipients(recipientWell as RecipientWellWithFindControlViewState, [
            { isValid: true, newPersona: recipientWell.findResultSet[0], newEmailAddress: null },
        ]);
    } else {
        recipientWell.findResultType = resultType;
        showHideFindResult(
            recipientWell,
            true /* shouldShowFindResult */,
            false /*shouldClearFindResult*/,
            recipients
        );
    }
});
